import { styled } from '@raskrask-dk/rr-components'

export const StyledPhoneField = styled('div', {
    alignItems: 'start',
    display: 'grid',
    gap: '$2',
    gridAutoFlow: 'column',
    gridTemplateColumns: '100px 1fr',
})
